<template>
  <div class="form-wrapper">
    <v-form
      v-bind="{ steps, text_top, text_bottom, type, form, terms }"
      @validate="validateStep"
      @submit="validateAll"
    >
      <template v-slot:step-0>
        <input
          name="designer"
          id="designer"
          v-model="form.designer"
          :placeholder="translation.designer"
        />
        <input
          name="furniture_type"
          id="furniture_type"
          v-model="form.furniture_type"
          :placeholder="translation.mobel"
        />
        <input
          name="material_name"
          id="material_name"
          v-model="form.material_name"
          :placeholder="translation.materiale"
        />
        <input
          name="condition"
          id="condition"
          v-model="form.condition"
          :placeholder="translation.stand"
        />
        <input
          name="furniture_price"
          id="furniture_price"
          v-model="form.furniture_price"
          :placeholder="translation.pris"
        />
        <div class="input-group">
          <span v-show="files_error" class="form-error">{{
            translation.error_field_missing
          }}</span>
          <input
            name="upload"
            type="file"
            id="upload"
            accept="image/png, image/jpeg"
            ref="myFiles"
            @change="uploadfiles()"
            multiple
          />

          <div class="input-placeholder" @click="openUpload">
            <span v-if="files.length == 0">
              {{ translation.no_files }}
            </span>
            <span v-else>
              {{ translation.success_files }} ({{ files.length }})</span
            >
          </div>
        </div>
      </template>
      <template v-slot:step-1>
        <div class="input-group">
          <span v-show="errors.has('form-2.name')" class="form-error">{{
            translation.error_field_format
          }}</span>
          <input
            id="name"
            name="name"
            v-model="form.name"
            :placeholder="translation.name"
            v-validate="'required'"
            data-vv-scope="form-2"
          />
        </div>

        <div class="input-group">
          <span v-show="errors.has('form-2.address')" class="form-error">{{
            translation.error_field_format
          }}</span>
          <input
            id="address"
            v-validate="'required'"
            name="address"
            v-model="form.address"
            :placeholder="translation.postnumber"
            data-vv-scope="form-2"
          />
        </div>

        <div class="input-group">
          <span v-show="errors.has('form-2.phone')" class="form-error">{{
            translation.error_field_format
          }}</span>
          <input
            v-validate="'required|decimal'"
            id="phone"
            name="phone"
            v-model="form.phone"
            :placeholder="translation.phone"
            key="phone-input"
            data-vv-scope="form-2"
          />
        </div>

        <div class="input-group">
          <span v-show="errors.has('form-2.email')" class="form-error">{{
            translation.error_field_missing
          }}</span>
          <input
            v-validate="'required|email'"
            id="email"
            name="email"
            v-model="form.email"
            :placeholder="translation.email"
            key="email-input"
            data-vv-scope="form-2"
          />
        </div>
      </template>
      <template v-slot:step-2>
        <div class="radio-wrapper">
          <span v-show="errors.has('form-3.radio-group')" class="form-error">{{
            translation.error_field_missing
          }}</span>
          <label for="radio-group">
            {{ translation.flow_form_agreed }}
          </label>
          <ul class="custom-radio-buttons">
            <li>
              <input
                v-model="form.barter"
                value="yes"
                type="radio"
                id="rb-1"
                name="radio-group"
                class="radio"
                v-validate="'required'"
                data-vv-scope="form-3"
              />

              <label for="rb-1">{{ translation.yes }}</label>
            </li>
            <li>
              <input
                v-model="form.barter"
                value="no"
                type="radio"
                id="rb-2"
                name="radio-group"
                class="radio"
                data-vv-scope="form-3"
              />
              <label for="rb-2">{{ translation.no }}</label>
            </li>
          </ul>
        </div>

        <textarea
          v-model="form.message"
          name="message"
          :placeholder="translation.comment"
        ></textarea>
      </template>
    </v-form>
  </div>
</template>

<script>
import vForm from "./form.vue";
import objectToFormData from "object-to-formdata";

export default {
  props: {
    steps: { required: true, type: String },
    text_top: { required: false, type: String },
    text_bottom: { required: false, type: String },
    type: { required: false, type: String },
    terms: { required: true, type: String },
  },
  components: {
    vForm,
  },
  data() {
    return {
      form: {
        url: window.location.href,
      },
      translation: this.$translations.form,
      files_error: false,
      files: [],
      formData: "",
    };
  },
  methods: {
    reset() {
      this.form = {
        url: window.location.href,
      };
      this.files = [];
    },
    uploadfiles() {
      this.files = this.$refs.myFiles.files;
    },
    openUpload() {
      this.$refs.myFiles.click();
    },
    validateStep(scope) {
      if (this.files.length === 0) {
        this.files_error = true;
      } else {
        this.$validator.validateAll(scope).then((isValid) => {
          if (isValid) {
            this.$children[0].activeStep++;
          }
        });
      }
    },
    validateAll(scope) {
      this.$validator.validateAll(scope).then((isValid) => {
        if (isValid) {
          this.formData = new FormData();
          let additionalData = {
            cid: document.querySelector("#cid_field").value,
            gclid: document.querySelector("#gclid_field").value,
          };

          Object.keys(this.form).forEach((key) =>
            this.formData.append(key, this.form[key])
          );

          Array.from(this.files).forEach((file) => {
            this.formData.append("files[]", file);
          });

          Object.keys(additionalData).forEach((key) =>
            this.formData.append(key, additionalData[key])
          );

          this.$children[0].send(this.formData, "sell");
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.form-wrapper {
  .step {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: baseline;
    font-family: $font-text;

    > * {
      width: calc(50% - 10px);

      @include res(tab-p) {
        width: 100%;
      }
    }

    textarea {
      width: 100%;
    }

    button,
    input[type="submit"] {
      @include button(#ffffff, 15px, 10px);
      line-height: 20px;
      background-color: $dark-grey;
      border: 0;
      &::before {
        @include button-hover($bg: #5C5C5C);
      }

      @include res(tab-p) {
        margin-bottom: 8px;
      }
    }

    input[type="file"] {
      display: none;
    }

    .input-placeholder {
      @include button(#ffffff, 15px, 20px);
      background-color: #c7c7c7;
      border: 0;
      width: 100%;
      cursor: pointer;

      &::before {
        @include button-hover($bg: #9c9c9c);
      }

      span {
        color: $dark-grey;
      }

      &:hover {
        span {
          color: $white;
        }
      }
    }

    .input-group {
      position: relative;

      input {
        width: 100%;
      }

      .form-error {
        position: absolute;
        top: -17px;
      }

      input[type="upload"] {
        padding: 8px 20px;
      }
    }

    .radio-wrapper {
      margin-bottom: 20px;
      ul li {
        list-style: none;
        display: inline;
      }

      label {
        display: inline-block;
        margin-bottom: 8px;
        color: $dark-grey;
        font-size: 14px;
        line-height: 20px;
      }

      input[type="radio"] {
        appearance: none;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        vertical-align: middle;
        margin-bottom: 5px;
        position: relative;
        cursor: pointer;
        outline: 0;
        overflow: hidden;
        border: 2px solid $brown;
        padding: 7px;

        &:checked:after {
          transform: translate3d(-50%, -50%, 0) scale(1, 1);
        }

        &:after {
          position: absolute;
          content: "";
          top: 50%;
          left: 50%;
          border-radius: 50%;
          transition: all 0.1s;
          border: 4px solid $brown;
          transform: translate3d(-50%, -50%, 0) scale(0, 0);
        }
      }
    }
  }
}
</style>
